var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled, { useTheme } from "styled-components";
export var Tags = function (_a) {
    var product = _a.product;
    var theme = useTheme();
    var tagName = function (tag) {
        switch (tag) {
            case "new":
                return "Nuevo";
            case "top":
                return "Lo más vendido";
            default:
                return tag;
        }
    };
    return (product.tags &&
        Object.values(product.tags).filter(function (t) { return t === true; }).length > 0 && (React.createElement(TagsContainer, null, product.tags &&
        Object.keys(product.tags).map(function (tag, i) {
            return product.tags[tag] && (React.createElement(TagContainer, { className: tag, key: i }, tagName(tag)));
        }))));
};
var TagsContainer = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  margin-bottom: 5px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  margin-bottom: 5px;\n"])));
var TagContainer = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", ";\n  color: #fff;\n  display: block;\n  font-size: 0.5rem;\n  font-weight: bold;\n  padding: 0.25rem 0.5rem;\n  text-align: center;\n  text-transform: uppercase;\n  width: fit-content;\n\n  &.new {\n    background-color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  border-radius: ", ";\n  color: #fff;\n  display: block;\n  font-size: 0.5rem;\n  font-weight: bold;\n  padding: 0.25rem 0.5rem;\n  text-align: center;\n  text-transform: uppercase;\n  width: fit-content;\n\n  &.new {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.primarioHover;
}, function (_a) {
    var theme = _a.theme;
    return theme.verySmallBorderRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme.go;
});
var templateObject_1, templateObject_2;
